import * as React from "react";
const SvgCropFree = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M2 6V3.33333C2 2.6 2.6 2 3.33333 2H6V3.33333H3.33333V6H2ZM2 10H3.33333V12.6667H6V14H3.33333C2.6 14 2 13.4 2 12.6667V10ZM12.6667 12.6667H10V14H12.6667C13.4 14 14 13.4 14 12.6667V10H12.6667V12.6667ZM10 2H12.6667C13.4 2 14 2.6 14 3.33333V6H12.6667V3.33333H10V2Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M7.30236 5.54321C7.27543 5.14089 7.59587 4.7998 8.00078 4.7998C8.40831 4.7998 8.72968 5.14514 8.69872 5.5498L8.44268 8.89619C8.42562 9.11919 8.23894 9.29147 8.01435 9.29147H7.95518C7.72903 9.29147 7.54161 9.11686 7.52656 8.89215L7.30236 5.54321Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M7.98287 11.2165C8.33874 11.2165 8.62723 10.9292 8.62723 10.5748C8.62723 10.2204 8.33874 9.93314 7.98287 9.93314C7.627 9.93314 7.33851 10.2204 7.33851 10.5748C7.33851 10.9292 7.627 11.2165 7.98287 11.2165Z",
	fill: "currentColor"
}));
export default SvgCropFree;
